import { ISearchAzureSavingsPlanOrders, IAzureSavingsPlanOrders } from './azureSavingsPlanOrders.model';
import { IApiResponse, ISearchResponse } from '../../../common/models/common';
import request from '../../../utils/request';

class AzureSavingsPlanOrdersService {
  ENDPOINT = '/azure-savings-plan-orders';

  public async searchAzureSavingsPlanOrders(
    searchParams?: ISearchAzureSavingsPlanOrders
  ): Promise<IApiResponse<ISearchResponse<IAzureSavingsPlanOrders>>> {
    const url = `${this.ENDPOINT}/search`;
    return request({ url, method: 'POST', data: searchParams }).then((res) => {
      return res.data;
    });
  }

  public async getAzureSavingsPlanOrdersById(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'GET' }).then((res) => {
      return res.data;
    });
  }

  public async saveAzureSavingsPlanOrders(data: IAzureSavingsPlanOrders): Promise<any> {
    const { id, ...restData } = data;
    if (id > 0) {
      const url = `${this.ENDPOINT}/${id}`;
      return request({ url, method: 'PUT', data: restData }).then((res) => {
        return res.data;
      });
    } else {
      const url = `${this.ENDPOINT}`;
      return request({ url, method: 'POST', data: restData }).then((res) => {
        return res.data;
      });
    }
  }

  public async deleteAzureSavingsPlanOrders(id: number): Promise<any> {
    const url = `${this.ENDPOINT}/${id}`;
    return request({ url, method: 'DELETE' }).then((res) => {
      return res.data;
    });
  }

  public async exportExcelFile(searchParams?: ISearchAzureSavingsPlanOrders): Promise<any> {
    const url = `back-ground-processes/export-excel`;
    return request({
      url,
      method: 'POST',
      data: searchParams,
    }).then((res) => {
      return res;
    });
  }
}
export default new AzureSavingsPlanOrdersService();
